import React from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import axiosInstance from "../../../../../Services/axiosCommon";
import { NuInput, NuMobileNumber } from "../../../../../Components/Utils/Input";

export default function AddPurchaserModal({ isOpen, onClose, onPurchaserCreated }) {
  const formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      phone: "",
      countryCode: "",
    },
    validationSchema: yup.object({
      name: yup.string().required("Name is required"),
      email: yup.string().email("Invalid email").required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append(
        "json_data",
        JSON.stringify({
          name: values.name || "",
          designation: "localPurchaser",
          email: values.email || "",
          phone: values.phone || "",
          countryCode: values.countryCode || "",
        })
      );
      try {
        const response = await axiosInstance.post("/user/create-user", formData);
        if (response.data?.status) {
          resetForm();
          if (onPurchaserCreated) onPurchaserCreated();
          onClose();
        }
      } catch (error) {
        console.error("Error creating purchaser:", error);
      }
    },
  });

  if (!isOpen) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
      <div className="animate-scale-in w-[60%] max-h-[80vh] bg-white py-2 px-4 rounded-md shadow-lg overflow-y-scroll">
        <h2 className="text-lg font-normal text-[12px]">Add Local Purchaser</h2>
        <form onSubmit={formik.handleSubmit}>
          <div className="mb-4 flex flex-wrap">
            <NuInput
              type="text"
              label="Name"
              placeholder="Enter Name"
              formik={formik}
              name="name"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuInput
              type="email"
              label="Email"
              placeholder="Email"
              formik={formik}
              name="email"
              isRequired={true}
              width="w-full md:w-1/3 md:-mt-2"
            />
            <NuMobileNumber
              nunCode="countryCode"
              label="Phone"
              placeholder="Phone"
              formik={formik}
              name="phone"
              width="w-full md:w-1/3 md:-mt-2"
            />
          </div>
          <div className="flex justify-end">
            <button
              type="button"
              onClick={onClose}
              className="px-5 py-[9px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="bg-[#048178] px-5 py-[9px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
            >
              Add
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
